/* AUSTRALIA v57.0.0 generated release bundle. Canonical filenames are retained to avoid a parallel runtime. */

/* source: av-vnext-v45.js */
(() => {
  'use strict';

  const body = document.body;
  if (!body) return;

  body.classList.add('av-v45');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canObserve = 'IntersectionObserver' in window;
  let revealObserver = null;

  const revealElement = (element) => element.classList.add('is-visible');

  if (!reducedMotion && canObserve) {
    revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        revealElement(entry.target);
        revealObserver.unobserve(entry.target);
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -4% 0px'
    });
  }

  const setRevealAttributes = (scope = document) => {
    const selectors = [
      '.av-favorites__header',
      '.av-favorites-card',
      '.av44-compact-start__header',
      '.av44-compact-start__card',
      '.av-protein-routine__header',
      '.av-protein-routine__card',
      '.av-home-journal__header',
      '.av43-decision__inner',
      '.avp4-evidence__head',
      '.avp4-evidence__item'
    ];

    scope.querySelectorAll(selectors.join(',')).forEach((element, index) => {
      if (!element.hasAttribute('data-av45-reveal')) {
        element.setAttribute('data-av45-reveal', 'up');
        element.style.setProperty('--av45-delay', `${Math.min(index % 4, 3) * 70}ms`);
      }

      if (reducedMotion || !revealObserver) revealElement(element);
      else revealObserver.observe(element);
    });
  };

  const normalizeEmptyModules = (scope = document) => {
    scope.querySelectorAll('[data-av45-optional], .avc14-merch, .av-pdp-v3__related').forEach((element) => {
      const hasMedia = element.querySelector('img, video, iframe');
      const text = element.textContent.replace(/\s+/g, ' ').trim();
      if (!hasMedia && text.length < 4) element.hidden = true;
    });
  };

  const localizeInterface = (scope = document) => {
    const replacements = new Map([
      ['Most relevant', 'Mais relevantes'],
      ['Best selling', 'Mais vendidos'],
      ['Newest', 'Mais recentes'],
      ['Oldest', 'Mais antigos'],
      ['Final sale', 'Venda final']
    ]);
    scope.querySelectorAll('option, button, summary, [role="option"]').forEach((element) => {
      const value = element.textContent.trim();
      if (replacements.has(value)) element.textContent = replacements.get(value);
    });
  };

  const makeExternalLinksSafe = (scope = document) => {
    scope.querySelectorAll('a[target="_blank"]').forEach((link) => {
      const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
      rel.add('noopener');
      rel.add('noreferrer');
      link.setAttribute('rel', [...rel].join(' '));
    });
  };

  const optimizeMedia = (scope = document) => {
    scope.querySelectorAll('img').forEach((image) => {
      image.decoding ||= 'async';
      const hero = image.closest('.av-world-hero, [data-au-hero-media]');
      if (!hero && !image.hasAttribute('loading')) image.loading = 'lazy';
    });
  };

  const initialize = (scope = document) => {
    setRevealAttributes(scope);
    normalizeEmptyModules(scope);
    localizeInterface(scope);
    makeExternalLinksSafe(scope);
    optimizeMedia(scope);
  };

  initialize();
  requestAnimationFrame(() => body.classList.add('av-v45-motion-ready'));

  /*
   * Content is more important than animation. This safety net prevents a
   * browser/app interaction from leaving an editorial module invisible.
   */
  window.setTimeout(() => {
    document.querySelectorAll('[data-av45-reveal]:not(.is-visible)').forEach(revealElement);
  }, 1800);

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:reorder', () => initialize());
  document.addEventListener('shopify:section:select', (event) => {
    event.target.querySelectorAll('[data-av45-reveal], [data-av-reveal]').forEach(revealElement);
  });

  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('video[autoplay]').forEach((video) => {
      if (document.hidden) video.pause();
      else if (!reducedMotion && video.closest('.is-visible, .av-world-hero')) video.play().catch(() => {});
    });
  });
})();;

(() => {
  'use strict';

  window.__avCartDrawerA11y?.abort?.();
  const controller = new AbortController();
  window.__avCartDrawerA11y = controller;

  const syncDrawer = (drawer, isOpen) => {
    if (!drawer) return;
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-hidden', String(!isOpen));
  };

  const findDrawer = (root = document) => {
    if (root?.matches?.('cart-drawer#cart-drawer')) return root;
    return root?.querySelector?.('cart-drawer#cart-drawer') || document.querySelector('cart-drawer#cart-drawer');
  };

  const syncCurrentState = (root = document) => {
    const drawer = findDrawer(root);
    syncDrawer(drawer, drawer?.classList.contains('is-open') === true);
  };

  document.addEventListener('theme:cart-drawer:open', (event) => {
    syncDrawer(event.detail?.target || findDrawer(), true);
  }, { signal: controller.signal });

  document.addEventListener('theme:cart-drawer:close', () => {
    syncDrawer(findDrawer(), false);
  }, { signal: controller.signal });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target?.matches?.('[data-section-type="cart-drawer"]') || event.target?.querySelector?.('cart-drawer#cart-drawer')) {
      syncCurrentState(event.target);
    }
  }, { signal: controller.signal });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncCurrentState(), { once: true, signal: controller.signal });
  } else {
    syncCurrentState();
  }
})();

/* source: av-v46-system.js */
/* Australia Vibes v46 — shared production guardrails. */
(() => {
  'use strict';
  document.documentElement.classList.add('av46-js');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initReveals = () => {
    const elements = document.querySelectorAll('[data-av-reveal]');
    if (!elements.length || reduced || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    elements.forEach((element) => observer.observe(element));
  };

  const normalizeSortLabels = (scope = document) => {
    const labels = new Map([
      ['manual', 'Mais relevantes'], ['relevance', 'Mais relevantes'],
      ['best-selling', 'Mais vendidos'], ['title-ascending', 'Nome: A–Z'],
      ['title-descending', 'Nome: Z–A'], ['price-ascending', 'Menor preço'],
      ['price-descending', 'Maior preço'], ['created-ascending', 'Mais antigos'],
      ['created-descending', 'Novidades']
    ]);
    scope.querySelectorAll('select[name="sort_by"] option').forEach((option) => {
      if (labels.has(option.value)) option.textContent = labels.get(option.value);
    });
    scope.querySelectorAll('[data-sort-link]').forEach((link) => {
      if (labels.has(link.dataset.value)) link.textContent = labels.get(link.dataset.value);
    });
  };

  const cleanUnitPrice = (scope = document) => {
    scope.querySelectorAll('.price-per-item__container, [data-av-unit-price], .product-unit-price').forEach((node) => {
      if (node.matches('.price-per-item__container') && node.querySelector('[data-av53-quantity], [data-quantity-input]')) {
        node.hidden = false;
        node.removeAttribute('aria-hidden');
        node.removeAttribute('data-av47-invalid-unit-price');
        return;
      }
      const text = node.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (!text || text === '/' || text === 'preço unitário / por' || text === 'preço unitário por') {
        node.hidden = true;
        node.setAttribute('aria-hidden', 'true');
      }
    });
  };

  const localizeLegacyMessages = (scope = document) => {
    const finalSaleEnglish = "Final sale products can't be returned or exchanged.";
    const finalSalePortuguese = document.body?.dataset.avFinalSaleMessage;
    if (!finalSalePortuguese) return;
    scope.querySelectorAll('[role="tooltip"], .tooltip, [data-final-sale-message]').forEach((node) => {
      if (node.textContent.trim() === finalSaleEnglish) node.textContent = finalSalePortuguese;
    });
  };

  const syncPurchaseState = (scope = document) => {
    scope.querySelectorAll('[data-product-id], [id^="MainProduct--"]').forEach((container) => {
      const selected = container.querySelector('select[name="id"] option:checked');
      const input = container.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]');
      const addButton = container.querySelector('button[name="add"], [data-add-to-cart]');
      let available = addButton ? !addButton.disabled : true;
      if (selected && selected.disabled) available = false;
      if (input && input.disabled) available = false;
      container.dataset.avPurchaseState = available ? 'available' : 'unavailable';
      container.querySelectorAll('[data-av-stock-state]').forEach((state) => {
        state.textContent = available ? 'Disponível para envio' : 'Indisponível no momento';
      });
    });
  };

  const markEmptySections = (scope = document) => {
    scope.querySelectorAll('#MainContent > .shopify-section').forEach((section) => {
      const meaningful = section.querySelector('img, video, form, product-form, h1, h2, h3, p:not(:empty), [data-au-proof-line], .shopify-app-block');
      if (meaningful) {
        section.removeAttribute('data-av-empty');
      } else {
        section.dataset.avEmpty = 'true';
      }
    });
  };

  const refresh = (scope = document) => {
    normalizeSortLabels(scope);
    cleanUnitPrice(scope);
    localizeLegacyMessages(scope);
    syncPurchaseState(scope);
    markEmptySections(scope);
  };

  document.addEventListener('DOMContentLoaded', () => {
    initReveals();
    refresh();
  }, { once: true });
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[name="id"], [data-option-select], select[name="sort_by"]')) return;
    window.requestAnimationFrame(() => refresh(event.target.closest('section, [data-product-id]') || document));
  });
  document.addEventListener('shopify:section:load', (event) => refresh(event.target));
  document.addEventListener('shopify:section:select', (event) => refresh(event.target));
})();;

/* source: av-v47-final-edit.js */
/* Australia Vibes v47 — idempotent storefront QA and terminology guard. */
(() => {
  'use strict';
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const fold = (value) => normalize(value).toLocaleLowerCase('pt-BR');

  function localizeSort(root = document) {
    const labels = new Map([
      ['manual', 'Mais relevantes'], ['relevance', 'Mais relevantes'], ['best-selling', 'Mais vendidos'],
      ['title-ascending', 'Nome: A–Z'], ['title-descending', 'Nome: Z–A'], ['price-ascending', 'Menor preço'],
      ['price-descending', 'Maior preço'], ['created-ascending', 'Mais antigos'], ['created-descending', 'Novidades']
    ]);
    root.querySelectorAll('select[name="sort_by"] option').forEach((option) => {
      const label = labels.get(option.value);
      if (label) option.textContent = label;
    });
  }

  function hideBrokenUnitPrices(root = document) {
    root.querySelectorAll('.price-per-item__container, .unit-price, .price__unit, .product__unit-price, [data-unit-price]').forEach((node) => {
      if (node.matches('.price-per-item__container') && node.querySelector('[data-av53-quantity], [data-quantity-input]')) {
        node.hidden = false;
        node.removeAttribute('aria-hidden');
        node.removeAttribute('data-av47-invalid-unit-price');
        return;
      }
      const text = fold(node.textContent);
      const hasNumber = /\d/.test(text);
      const hasMeasure = /\b(?:kg|mg|g|ml|l)\b|unidade|un\.|barra|porção/i.test(text);
      if (!text || !hasNumber || !hasMeasure) {
        node.hidden = true;
        node.setAttribute('data-av47-invalid-unit-price', '');
      }
    });
  }

  function standardizePurchaseLanguage(root = document) {
    root.querySelectorAll('[data-av-governed-label]').forEach((node) => {
      const label = node.querySelector('[data-add-to-cart-text], .btn__text, .button__text') || node;
      if (label === node && node.children.length) return;
      const governedLabel = normalize(node.getAttribute('data-av-governed-label'));
      if (governedLabel) label.textContent = governedLabel;
    });
  }

  function reconcileAvailability(root = document) {
    root.querySelectorAll('[data-av-pdp-v3], [data-product-section], product-info').forEach((scope) => {
      const add = scope.querySelector('[name="add"], [data-add-to-cart], .product-form__submit');
      if (!add) return;
      const unavailable = add.disabled || add.getAttribute('aria-disabled') === 'true';
      if (!unavailable) return;
      scope.querySelectorAll('[data-av-availability-message], .av43-trust-item').forEach((message) => {
        if (/disponível para envio/i.test(message.textContent || '')) message.hidden = true;
      });
    });
  }

  function run(root = document) { localizeSort(root); hideBrokenUnitPrices(root); standardizePurchaseLanguage(root); reconcileAvailability(root); }
  const boot = () => run(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', (event) => run(event.target));
  document.addEventListener('shopify:section:reorder', boot);
})();;

/* source: av-v48-system.js */
(() => {
  'use strict';

  const ready = (fn) => document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', fn, { once: true })
    : fn();

  const copy = document.documentElement.lang?.toLowerCase().startsWith('en')
    ? { adding: 'Adding…', added: 'Added to cart', error: 'Could not add. Try again.' }
    : { adding: 'Adicionando…', added: 'Adicionado à sacola', error: 'Não foi possível adicionar. Tente novamente.' };

  const normalized = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const announce = (message) => {
    let live = document.getElementById('AV48LiveStatus');
    if (!live) {
      live = document.createElement('div');
      live.id = 'AV48LiveStatus';
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('aria-atomic', 'true');
      document.body.appendChild(live);
    }
    live.textContent = '';
    requestAnimationFrame(() => { live.textContent = message; });
  };

  class AV48ProductState {
    constructor(root) {
      this.root = root;
      this.button = null;
      this.label = null;
      this.originalLabel = '';
      this.pending = false;
      this.timer = 0;
      this.reconcile = this.reconcile.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.bind();
    }

    bind() {
      this.root.addEventListener('submit', this.onSubmit, true);
      this.observer = new MutationObserver(this.reconcile);
      this.observer.observe(this.root, {
        subtree: true,
        childList: true,
        attributes: true,
        characterData: true,
        attributeFilter: ['disabled', 'value', 'data-preorder', 'data-av-purchase-state']
      });
      this.reconcile();
    }

    elements() {
      this.button = this.root.querySelector('button[name="add"], [data-add-to-cart]');
      this.label = this.button?.querySelector('[data-add-to-cart-text], .btn__text') || this.button;
      if (this.label && !this.originalLabel) this.originalLabel = normalized(this.label.textContent);
    }

    deriveState() {
      if (this.pending) return 'loading';
      this.elements();
      const formState = this.button?.closest('product-form')?.dataset.avPurchaseState;
      if (formState === 'preorder' || this.button?.dataset.preorder === 'true') return 'preorder';
      if (formState === 'sold_out') return 'sold_out';
      if (formState === 'unavailable') return 'unavailable';
      if (!this.button) return this.root.dataset.availability === 'available' ? 'available' : 'sold_out';
      if (!this.button.disabled) return 'available';
      const label = normalized(this.button.textContent).toLowerCase();
      return /esgot|sold out/.test(label) ? 'sold_out' : 'unavailable';
    }

    reconcile() {
      const state = this.deriveState();
      this.root.dataset.av48State = state;
      this.root.querySelectorAll('[data-av-stock-copy], .av40-fact__value').forEach((node) => {
        const text = normalized(node.textContent).toLowerCase();
        const availableClaim = /disponível para envio|em estoque|available to ship|in stock/.test(text);
        node.dataset.av48Contradiction = String(availableClaim && (state === 'sold_out' || state === 'unavailable'));
      });
      this.root.querySelectorAll('.product-soldout-notification, [data-av-notify-control]').forEach((node) => {
        const shouldShow = state === 'sold_out';
        node.hidden = !shouldShow;
        node.setAttribute('aria-hidden', String(!shouldShow));
      });
      this.hideBrokenUnitPrice();
    }

    hideBrokenUnitPrice() {
      this.root.querySelectorAll('.price-per-item, .product-unit-price, [data-av-unit-price], [data-product-unit-price]').forEach((node) => {
        const text = normalized(node.textContent).toLowerCase();
        const incomplete = !text || text === '/' || /preço unitário\s*\/\s*por|unit price\s*\/\s*per/.test(text);
        node.toggleAttribute('data-av48-invalid-unit-price', incomplete);
        node.classList.toggle('av48-invalid-unit-price', incomplete);
      });
    }

    onSubmit(event) {
      const form = event.target.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
      if (!form || !this.root.contains(form)) return;
      this.elements();
      if (!this.button || this.button.disabled) return;
      this.pending = true;
      this.root.dataset.av48State = 'loading';
      this.button.setAttribute('aria-busy', 'true');
      if (this.label) this.label.textContent = copy.adding;
      announce(copy.adding);
      clearTimeout(this.timer);
      this.timer = window.setTimeout(() => this.restore(), 4000);
    }

    success() {
      if (!this.pending) return;
      this.pending = false;
      clearTimeout(this.timer);
      this.elements();
      this.root.dataset.av48State = 'success';
      this.button?.removeAttribute('aria-busy');
      if (this.label) this.label.textContent = copy.added;
      announce(copy.added);
      this.timer = window.setTimeout(() => this.restore(), 900);
    }

    error() {
      if (!this.pending) return;
      this.pending = false;
      clearTimeout(this.timer);
      this.elements();
      this.button?.removeAttribute('aria-busy');
      if (this.label) this.label.textContent = this.originalLabel;
      announce(copy.error);
      this.reconcile();
    }

    restore() {
      this.pending = false;
      this.elements();
      this.button?.removeAttribute('aria-busy');
      if (this.label && this.originalLabel) this.label.textContent = this.originalLabel;
      this.reconcile();
    }
  }

  const productStates = [];

  const initProductStates = () => {
    document.querySelectorAll('[data-av-pdp-v3]').forEach((root) => {
      if (root.dataset.av48Bound === 'true') return;
      root.dataset.av48Bound = 'true';
      productStates.push(new AV48ProductState(root));
    });
  };

  const initReveals = () => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const elements = [...document.querySelectorAll('[data-av-reveal]')];
    if (!elements.length) return;
    document.documentElement.classList.add('av48-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
    elements.forEach((element) => observer.observe(element));
  };

  const localizeSorts = () => {
    document.querySelectorAll('select[name="sort_by"] option').forEach((option) => {
      if (option.value === 'most-relevant' && document.documentElement.lang?.toLowerCase().startsWith('pt')) {
        option.textContent = 'Mais relevantes';
      }
    });
  };

  ready(() => {
    initProductStates();
    initReveals();
    localizeSorts();

    document.addEventListener('theme:product:add-error', () => productStates.forEach((state) => state.error()));
    document.addEventListener('theme:cart-drawer:open', () => productStates.forEach((state) => state.success()));
    document.addEventListener('shopify:section:load', () => {
      initProductStates();
      localizeSorts();
    });

    if (typeof window.subscribe === 'function' && window.theme?.PUB_SUB_EVENTS) {
      if (window.theme.PUB_SUB_EVENTS.variantChange) {
        window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(() => productStates.forEach((state) => state.reconcile())));
      }
      if (window.theme.PUB_SUB_EVENTS.cartUpdate) {
        window.subscribe(window.theme.PUB_SUB_EVENTS.cartUpdate, () => productStates.forEach((state) => state.success()));
      }
    }
  });
})();;

/* source: av-v49-spec-release.js */
(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const setStatus = (control, key) => {
    const status = document.querySelector('[data-av-cookie-status]');
    if (!status) return;
    status.textContent = control.dataset[key] || '';
  };

  const openPreferences = (control) => {
    if (window.Shopify?.customerPrivacy?.showPreferences) {
      window.Shopify.customerPrivacy.showPreferences();
      setStatus(control, 'success');
      return true;
    }
    const nativeControl = document.querySelector('#shopify-pc__banner__btn-manage-prefs, #shopify-pc__prefs__header-decline, [data-shopify-customer-privacy-manage]');
    if (nativeControl) {
      nativeControl.click();
      setStatus(control, 'success');
      return true;
    }
    setStatus(control, 'unavailable');
    return false;
  };

  const bindCookieControls = (root = document) => {
    root.querySelectorAll('[data-av-cookie-preferences]').forEach((control) => {
      if (control.dataset.avCookieReady) return;
      control.dataset.avCookieReady = 'true';
      control.addEventListener('click', (event) => {
        event.preventDefault();
        if (openPreferences(control)) return;
        if (window.Shopify?.loadFeatures) {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1', onLoad: () => openPreferences(control) }]);
        }
      });
    });
  };

  const observeSensitiveSections = () => {
    if (!('IntersectionObserver' in window)) return;
    const visible = new Set();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      });
      document.body.classList.toggle('av49-sensitive-active', visible.size > 0);
    }, { threshold: 0.18 });
    document.querySelectorAll('.avp4-evidence, .av-b2b__form-card, .av-creator__form, .av49-trust').forEach((section) => observer.observe(section));
  };

  ready(() => {
    bindCookieControls();
    observeSensitiveSections();
  });

  document.addEventListener('shopify:section:load', (event) => bindCookieControls(event.target));
})();;

/* source: av-v52-zero-defect.js */
(() => {
  const isPortuguese = () => (document.documentElement.lang || '').toLowerCase().startsWith('pt');

  const normalizeText = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();

  const hideIncompleteUnitPrices = (root = document) => {
    root.querySelectorAll('.unit-price, .product__unit-price, .price__unit, [data-unit-price], [data-unit-price-wrapper]').forEach((node) => {
      const text = normalizeText(node.textContent || '');
      const incomplete = text === 'preço unitário / por' || text === 'preco unitario / por' || /^preç[o]? unit[aá]rio\s*\/\s*por$/.test(text);
      if (!incomplete) return;
      node.hidden = true;
      node.setAttribute('aria-hidden', 'true');
      node.dataset.av52InvalidUnitPrice = 'true';
    });
  };

  const localizeInterface = (root = document) => {
    if (!isPortuguese()) return;
    root.querySelectorAll('option').forEach((option) => {
      if (normalizeText(option.textContent || '') === 'most relevant') option.textContent = 'Mais relevantes';
    });
    root.querySelectorAll('.av39-pack-economics__format, .au-cta-fact__value, [data-av-format-label]').forEach((node) => {
      node.textContent = (node.textContent || '')
        .replace(/\bpouch\b/gi, 'pacote')
        .replace(/\bdisplay box\b/gi, 'caixa expositora')
        .replace(/\bdisplay\b/gi, 'caixa expositora');
    });
  };

  const syncSensitiveSticky = () => {
    const sensitive = document.body.classList.contains('av49-sensitive-active');
    document.querySelectorAll('cart-bar.cart-bar, .au-pdp-sticky-atc, [data-au-sticky-atc], .product-sticky-form, .product-sticky, .sticky-add-to-cart, [data-sticky-add-to-cart]').forEach((node) => {
      if (sensitive) {
        if (node.dataset.av52SensitiveHidden === 'true') return;
        node.dataset.av52SensitiveHidden = 'true';
        node.dataset.av52PreviousAriaHidden = node.getAttribute('aria-hidden') || '';
        node.setAttribute('aria-hidden', 'true');
        node.inert = true;
      } else if (node.dataset.av52SensitiveHidden === 'true') {
        const previous = node.dataset.av52PreviousAriaHidden;
        if (previous) node.setAttribute('aria-hidden', previous);
        else node.removeAttribute('aria-hidden');
        node.inert = false;
        delete node.dataset.av52SensitiveHidden;
        delete node.dataset.av52PreviousAriaHidden;
      }
    });
  };

  const prepare = (root = document) => {
    hideIncompleteUnitPrices(root);
    localizeInterface(root);
    syncSensitiveSticky();
  };

  const ready = () => {
    prepare();
    new MutationObserver(syncSensitiveSticky).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();

  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();;

/* source: av-v53-commerce.js */
(() => {
  const clampQuantity = (input, announce = true) => {
    const min = Number(input.min || 1);
    const max = input.max ? Number(input.max) : Infinity;
    const step = Number(input.step || 1);
    let value = Number.parseInt(input.value, 10);
    if (!Number.isFinite(value)) value = min;
    value = Math.max(min, Math.min(max, value));
    value = min + Math.round((value - min) / step) * step;
    value = Math.max(min, Math.min(max, value));
    input.value = String(value);
    const root = input.closest('[data-av53-quantity]');
    const status = root && root.querySelector('[data-av53-quantity-status]');
    if (status && announce) status.textContent = `Quantidade ${value}.`;
    return value;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-av53-quantity-minus],[data-av53-quantity-plus]');
    if (!button) return;
    const input = button.closest('[data-av53-quantity]')?.querySelector('[data-av53-quantity-input]');
    if (!input) return;
    const step = Number(input.step || 1);
    input.value = String(Number(input.value || input.min || 1) + (button.hasAttribute('data-av53-quantity-plus') ? step : -step));
    clampQuantity(input);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-av53-quantity-input]')) clampQuantity(event.target);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-av53-shipping-form]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('[name="postal_code"]');
    const provinceInput = form.querySelector('[name="province"]');
    const status = form.querySelector('[data-av53-shipping-status]');
    const button = form.querySelector('button[type="submit"]');
    const postal = (input.value || '').replace(/\D/g, '');
    // Release 6.5: a form without a state field (the cart) takes the state from the CEP, by the Correios ranges the 6.2 product page uses.
    if (form.matches('[data-av53-list]') && provinceInput && !provinceInput.value && postal.length === 8) {
      const head = Number(postal.slice(0, 5));
      const hit = [['SP', 1000, 19999], ['RJ', 20000, 28999], ['ES', 29000, 29999], ['MG', 30000, 39999], ['BA', 40000, 48999], ['SE', 49000, 49999], ['PE', 50000, 56999], ['AL', 57000, 57999], ['PB', 58000, 58999], ['RN', 59000, 59999], ['CE', 60000, 63999], ['PI', 64000, 64999], ['MA', 65000, 65999], ['PA', 66000, 68899], ['AP', 68900, 68999], ['AM', 69000, 69299], ['RR', 69300, 69399], ['AM', 69400, 69899], ['AC', 69900, 69999], ['DF', 70000, 72799], ['GO', 72800, 72999], ['DF', 73000, 73699], ['GO', 73700, 76799], ['RO', 76800, 76999], ['TO', 77000, 77999], ['MT', 78000, 78899], ['MS', 79000, 79999], ['PR', 80000, 87999], ['SC', 88000, 89999], ['RS', 90000, 99999]].find(([, from, to]) => head >= from && head <= to);
      if (hit) provinceInput.value = hit[0];
    }
    const province = String(provinceInput?.value || '').trim().toUpperCase();
    if (postal.length !== 8) {
      status.textContent = 'Informe um CEP válido com 8 números.';
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      return;
    }
    input.removeAttribute('aria-invalid');
    if (!/^[A-Z]{2}$/.test(province)) {
      status.textContent = form.dataset.av53StateRequired || 'Selecione o estado para calcular a entrega.';
      provinceInput?.setAttribute('aria-invalid', 'true');
      provinceInput?.focus();
      return;
    }
    provinceInput.removeAttribute('aria-invalid');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = 'Consultando opções de entrega…';
    try {
      const params = new URLSearchParams({
        'shipping_address[zip]': postal,
        'shipping_address[country]': 'Brazil',
        'shipping_address[province]': province
      });
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/shipping_rates.json?${params}`, { headers: { Accept: 'application/json' } });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload?.error || 'rate_error');
      const rates = Array.isArray(payload.shipping_rates) ? payload.shipping_rates : [];
      const list = form.querySelector('[data-av53-shipping-rates]');
      // Release 6.9 (D-43): with the free shipping rule on (au-r65-ship-state
      // renders the target only then), checkout makes the cheapest option free
      // once the products before discounts reach it, unless a R$ 0 option is
      // already there. The list says so instead of the price.
      let freeRate = null;
      const freeHost = document.querySelector('[data-au-r69-free-target]');
      if (freeHost && rates.length && !rates.some((rate) => Number(rate.price) === 0)) {
        try {
          const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })).json();
          if (Number(cart.original_total_price) >= Number(freeHost.dataset.auR69FreeTarget)) freeRate = rates.reduce((best, rate) => (Number(rate.price) < Number(best.price) ? rate : best), rates[0]);
        } catch (_) { /* the paid prices stay */ }
      }
      if (list) list.replaceChildren();
      if (!rates.length) {
        status.textContent = 'Nenhuma opção de entrega apareceu para esse CEP com essa sacola. Confira o frete ao finalizar a compra ou fale com o atendimento.';
      } else if (list && form.hasAttribute('data-av53-list')) {
        // Release 6.5 list mode (the cart): one line per rate, its name, the delivery days Shopify returns and the price. Nothing typed.
        const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
        const host = form.closest('[data-au-r65-days-range]') || form;
        const days = (rate) => {
          const d = Array.isArray(rate.delivery_days) ? rate.delivery_days.map(Number).filter(Number.isFinite) : [];
          if (!d.length || /\bdias?\b/i.test(rate.name || '')) return '';
          const min = d[0];
          const max = d[d.length - 1];
          if (min !== max) return (host.dataset.auR65DaysRange || '').replace('[[min]]', min).replace('[[max]]', max);
          return max === 1 ? host.dataset.auR65DaysOne || '' : (host.dataset.auR65DaysOther || '').replace('[[count]]', max);
        };
        for (const rate of rates) {
          const li = document.createElement('li');
          const name = document.createElement('span');
          const when = days(rate);
          name.textContent = when ? `${rate.name} · ${when}` : rate.name;
          const price = document.createElement('strong');
          price.textContent = rate === freeRate ? freeHost.dataset.auR69FreeLabel : formatter.format(Number(rate.price));
          li.append(name, price);
          list.append(li);
        }
        status.textContent = '';
      } else {
        const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
        status.textContent = rates.map((rate) => (rate === freeRate ? `${rate.name} ${freeHost.dataset.auR69FreeLine}` : `${rate.name} por ${formatter.format(Number(rate.price))}`)).join(' · ') + '. O prazo aparece ao finalizar a compra.';
      }
      document.dispatchEvent(new CustomEvent('australia:shipping-estimate', { detail: { result: rates.length ? 'success' : 'empty', rates, form } }));
    } catch (error) {
      status.textContent = 'Não foi possível calcular o frete agora. Sua sacola continua como estava. Tente de novo ou veja o frete ao finalizar a compra.';
      document.dispatchEvent(new CustomEvent('australia:shipping-estimate', { detail: { result: 'error', rates: [], form } }));
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  document.addEventListener('submit', (event) => {
    const blocked = event.target.closest('[data-av53-state="under_review"]');
    if (!blocked) return;
    event.preventDefault();
    const status = blocked.querySelector('[role="status"]');
    if (status) status.textContent = 'Este produto não está disponível e não pode ser adicionado à sacola.';
  }, true);
})();;

/* source: av-worldclass-qa.js */
(() => {
  const path = window.location.pathname.replace(/\/$/, '') || '/';

  const policyTitles = {
    '/policies/privacy-policy': 'Política de privacidade',
    '/policies/terms-of-service': 'Termos de uso',
    '/policies/shipping-policy': 'Entrega e prazos',
    '/policies/refund-policy': 'Trocas e reembolsos'
  };

  const replacements = new Map([
    ['Auto-renews, skip or cancel anytime.', 'Renovação automática. Pule, pause ou cancele quando quiser.'],
    ['Auto-renews, skip or cancel anytime', 'Renovação automática. Pule, pause ou cancele quando quiser.']
  ]);

  const normalizeAppCopy = (root = document) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let changed = false;
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const value = node.nodeValue.trim();
      if (replacements.has(value)) {
        node.nodeValue = node.nodeValue.replace(value, replacements.get(value));
        changed = true;
      }
    });

    return changed;
  };

  const canonicalRoutes = (() => {
    const runtimeRoutes = {
      '/products/kit-lancheira-real': '/products/kit-lanche-inteligente',
      '/pages/contato': '/pages/atendimento'
    };
    try {
      const routeNode = document.getElementById('AVCanonicalRoutes');
      const configuredRoutes = routeNode ? JSON.parse(routeNode.textContent || '{}') : {};
      return { ...configuredRoutes, ...runtimeRoutes };
    } catch (error) {
      return runtimeRoutes;
    }
  })();

  const normalizeLegacyLinks = (root = document) => {
    root.querySelectorAll?.('a[href]').forEach((link) => {
      // Release 6.8: a link to a place on this page (#…) is never rewritten.
      if ((link.getAttribute('href') || '').startsWith('#')) return;
      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      const canonicalPath = canonicalRoutes[url.pathname];
      if (!canonicalPath) return;
      url.pathname = canonicalPath;
      link.href = `${url.pathname}${url.search}${url.hash}`;
    });
  };

  const localizePolicy = () => {
    const title = policyTitles[path];
    if (!title) return;
    const heading = document.querySelector('main h1, #MainContent h1');
    if (heading) heading.textContent = title;
  };

  const run = (root = document) => {
    normalizeAppCopy(root);
    normalizeLegacyLinks(root);
    localizePolicy();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run(), { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver((mutations) => {
    let localized = false;
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) localized = normalizeAppCopy(node) || localized;
    }));
    if (localized) observer.disconnect();
  });

  const observeAsyncAppCopy = () => {
    if (!document.body) return;
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 12000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAsyncAppCopy, { once: true });
  } else {
    observeAsyncAppCopy();
  }
})();;
